
import { NgFor, NgIf, CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, ViewChild, ViewEncapsulation, forwardRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FileManagerComponent } from 'app/modules/admin/apps/file-manager/file-manager.component';
import { FileManagerService } from 'app/modules/admin/apps/file-manager/file-manager.service';
import { ItemPagination,assetsFilterFields, AssetsSearch } from 'app/modules/admin/apps/file-manager/file-manager.types';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { HttpClientModule } from "@angular/common/http";
import { MatTableModule } from '@angular/material/table';
import { iconTypes } from 'app/modules/admin/apps/file-manager/file-manager.constants';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { DocumentService } from 'app/services/document.service';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { MatExpansionModule, MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { EventService } from 'app/services/event.service';
import { Asset } from 'app/models/document';
import * as consts from 'app/shared/global-constants';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FileUploadModule} from 'ng2-file-upload';
import { Util } from 'app/models/util';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { fuseAnimations } from '@fuse/animations';
import { labelColorDefs } from 'app/modules/admin/apps/file-manager/file-manager.constants';
import { LabelService } from 'app/services/label.service';
import { FilterComponent } from '../filter/filter.component';
import { ToastrService } from 'ngx-toastr';
import { FavouriteService } from 'app/services/favourite.service';
import { FileSizePipe } from '@fuse/pipes/file-size.pipe';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { LockService } from 'app/services/lock.service';
import { RecentsDetailsComponent } from './recents-details/recents-details.component';
import { AuthService } from 'app/services/auth.service';
import { ActionRegistryService } from 'app/shared/action-registry.service';
import { DesktopAgentService } from 'app/services/desktop-agent.service';
import { ClickDebouncer } from 'app/shared/click-debouncer';
import { LpmConfig } from 'app/models/lpm.config';
import { NgxLoadingModule } from 'ngx-loading';
import { ActionDirective } from '@fuse/directives/action.directive';
import { DesktopAgentBannerComponent } from '../desktop-agent/desktop-agent-banner.component';
import { DndDraggableDirective } from 'ngx-drag-drop';
import { PermissionsService } from '../permissions/permissions.service';
import { IsDisplayedDirective } from '@fuse/directives/isDisplayed.directive';
import { LpmLabelPipe } from '@fuse/pipes/lpm-label.pipe';
import { FullNamePipe, getFullName } from '@fuse/pipes/full-name.pipe';

@Component({
  selector: 'app-recents',
  templateUrl: './recents.component.html',
  styleUrls: ['./recents.component.scss'],
  animations: [
    fuseAnimations,
    trigger('slideDown', [
      state('void', style({
        height: '0',
        opacity: '0',
        overflow: 'hidden',
      })),
      state('*', style({
        height: '*',
        opacity: '1',
      })),
      transition(':leave', [
        animate('0.3s ease-out')
      ]),
    ])
  ],
encapsulation: ViewEncapsulation.None,
standalone: true,
imports: [
    MatSidenavModule,
    RouterOutlet,
    NgIf,
    NgFor,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatOptionModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSortModule,
    HttpClientModule,
    MatTableModule,
    MatMenuModule,
    CommonModule,
    MatExpansionModule,
    FileUploadModule,
    MatMenuModule,
    CommonModule,
    MatExpansionModule,
    MatPaginatorModule,
    ScrollingModule,
    FuseLoadingBarComponent,
    FilterComponent,
    FileSizePipe,
    RecentsDetailsComponent,
    NgxLoadingModule,
    ActionDirective,
    DndDraggableDirective,
    forwardRef(() => IsDisplayedDirective),
    forwardRef(() => LpmLabelPipe),
    FullNamePipe,
    DesktopAgentBannerComponent
],
})
export class RecentsComponent {
    @Input() defaultView: string = null;
    @Input() lpm: LpmConfig = new LpmConfig();
    @ViewChild('matDrawer', { static: true }) matDrawer: MatDrawer;
    @ViewChild('viewport', { static: false }) viewport: CdkVirtualScrollViewport;

    drawerMode: 'side' | 'over';
    selectedItem: Asset;
    parentItem: Asset;
    //items1: Items;
    assets: Asset[] = [];
    folders = null;
    files = null;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    labelColors: any;
    labels = [];
    viewMode: any;

    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    @ViewChild(MatSort) private _sort: MatSort;
    page: ItemPagination = new ItemPagination();
    isLoading: boolean = true;
    iconTypes: any = iconTypes;

    // we create an object that contains coordinates 
    menuTopLeftPosition = { x: 0, y: 0 };

    // reference to the MatMenuTrigger in the DOM 
    @ViewChild('fmItemActionMenuItemTrigger', { static: true }) matMenuTrigger!: MatMenuTrigger;
    @ViewChild('filterPanel', { static: true }) filterPanel: MatExpansionPanel;
    @ViewChild('multiItemSelectPanel', { static: true }) multiItemSelectPanel: MatExpansionPanel;
    @ViewChild('statsPanel', { static: true }) statsPanel: MatExpansionPanel;
    
    selectedRows: Asset[] = [];
    lastSelectedIndex: number = -1;
    routeFolderId = null;
    isStatsPanelOpen = false;

    public paths = [];
    pageLimitList = consts.pagelimits;
    total = 0;
    showScrollToTopButton = false;
    private scrollSubscription: Subscription;

    //private _isUploading = new BehaviorSubject<boolean>(false);
    //public readonly uploadInitiated: Observable<boolean> = this._isUploading.asObservable();
    fileOverSubject: Subject<boolean> = new Subject<boolean>();
    fileOverSubscription: Subscription;

    disableAll: boolean = false;
    isError: boolean = false;
    error: string = null;
    public currentFolderId: string = "";
    radius: number;
    color: string;
    searchQuery:string=""
    assetsFilterFields:assetsFilterFields=new assetsFilterFields()
    assetsSearch:AssetsSearch=new AssetsSearch()

    teamDecorator = {};
    itemDecoratorComplete: boolean = false;
    loggedInUserId:string=null
    subs = new Subscription();

    assetId = null;
    activeTab  = null;
    isAllRowsSelected:boolean = false;
    
    // ...

    // -----------------------------------------------------------------------------------------------------

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        public _fileManagerComponent: FileManagerComponent,
        private _fileManagerService: FileManagerService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        public docService: DocumentService,
        public eventSer: EventService,
        public util: Util,
        private labelService :LabelService,
        private toasterService :ToastrService,
        private favService :FavouriteService,
        public sanitizer: DomSanitizer,
        private lockService: LockService,
        private _fuseConfirmationService: FuseConfirmationService,
        private titleService: Title,
        private authService: AuthService,
        private _permissionsService: PermissionsService,
        private _actionRegistry: ActionRegistryService,
        private _desktopAgentService: DesktopAgentService,
    ) {  }

    private readonly _clicks = new ClickDebouncer();
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        if(!this.util.getIsWebApp()) this.titleService.setTitle("DMS - Recents");
        // this.loggedInUserId=this.util.getUserFromSession().id
        this.configFilter()
        this.page.size = Number(this.util.getPageLimit());
        this.getRecentAssets()
        
        // Set the defaults
        this._fileManagerService.registerIcons();
        // TODO - set viewMode default based on user preference
        this.viewMode = this._fileManagerService.viewMode;
        // // Get the label colors
        this.labelColors = labelColorDefs;
        this.getLabels();

        this.subs.add(
            this.eventSer.getData.subscribe((data) => {
                 this.getRecentAssets();
              })
          );
          this.subs.add(
            this.eventSer.resetRowsSelection.subscribe(data=>{
                this.cancelBulkAction()
              })
          );
      
        this._fuseMediaWatcherService.onMediaQueryChange$('(min-width: 1200px)')
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((state) => {
            // Calculate the drawer mode
            this.drawerMode = state.matches ? 'side' : 'over';

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    ngAfterViewInit(): void {
       
    }

    async getRecentAssets() {
        this.isLoading = true;
        this.assets=[];
        this.resetSelectedRows();
        this.assetsSearch.assetType = 'FILE'
        this.docService.getAssets(this.page, this.assetsSearch).then((res)=>{
            this.assets = this.docService.getData(res)
            const meta = this.docService.getMeta(res)
            this.renderTeamMembers();
            this.total = meta.total
            this.isLoading=false
        }).catch(error=>{
            console.log(error)
        })
    }

    onPageChanged(e: PageEvent) {
        this.page.length = e.length;
        this.page.size = e.pageSize;
        this.page.page = e.pageIndex;
        this.util.setPageLimit(this.page.size);
        this.getRecentAssets()
    }

    sortData(sort : Sort){
        this.page.orderOn = sort.active;
        this.getRecentAssets()
    }

    getLabels() {
        this.labelService.getLabels().then((res) => {
            this.labels = this.labelService.getData(res);
        }).catch((error) => {
            console.log(error);
        })
    }

    getAssetLabels(assignedLabelIds:string){
        return this.labels.filter(label=>{
            return assignedLabelIds?.includes(label.id)
        })
    }
    
    ngOnDestroy(): void {
        this.subs.unsubscribe();
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        if (this.scrollSubscription) {
            this.scrollSubscription.unsubscribe();
        }
    }

    subscribeToScrollEvent() {
        this.scrollSubscription = this.viewport.elementScrolled().subscribe(event => {
            this.handleScrollEvent(event);
        });
      }
    
    handleScrollEvent(event) {
        this.showScrollToTopButton = this.viewport.getOffsetToRenderedContentStart() > 30;
    }

    scrollToTop() {
        // Use the viewport's API to scroll to the top
        //this.viewport.scrollToOffset(0);
        //this.viewport.scrollToIndex(0);
        this.viewport.scrollTo({ top: 0, behavior: 'smooth' });
        this.showScrollToTopButton = false;
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On backdrop clicked
     */
    onBackdropClicked(): void {
        // Go back to the list
        this._router.navigate(['./'], { relativeTo: this._activatedRoute });

        // Mark for check
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    viewDetails(): void {
        const routerPath = this._activatedRoute.snapshot.url.join('/');
        //console.log(routerPath);
        const currentFolderId = routerPath.split('/').pop();
        const parentFolderId = this._fileManagerService.getItemById(currentFolderId);
        if (parentFolderId) {
            console.log(parentFolderId);
        }

        if (currentFolderId) {
            //console.log(currentFolderId);
            this._router.navigate(['apps/file-manager/folders/' + currentFolderId + '/details/' + currentFolderId]);
        } else {
            console.log('is root');
        }
    }

    /**
     * 
     */
    viewStats(): void {
        console.log('viewStats');
    }

    /**
     * Translate the asset size to human readable format KB and MB
     */
    getAssetSize(asset: Asset): string {
        let size = 0;
        size = asset.size ? asset.size : 0;
        size = size / 1000;
        if (size < 1000) {
            return size.toFixed(1) + ' KB';
        } else {
            const sizeInMb = size / 1024;
            return sizeInMb.toFixed(1) + ' MB';
        }
    }
    
    /**
     * Toggle the viewMode between 'grid' and 'cards'
     *
     * @param viewMode
     */
    toggleViewMode(): void {
        this.multiItemSelectPanel.close();
        this._fileManagerService.viewMode = this._fileManagerService.viewMode === 'grid' ? 'cards' : 'grid';
        this.viewMode = this._fileManagerService.viewMode;
    }

    /** 
     * Method called when the user click with the right button 
     * @param event MouseEvent, it contains the coordinates 
     * @param item Our data contained in the row of the table 
     */
    onRightClick(event: MouseEvent, selectedItem: Asset): void {

        // preventDefault avoids to show the visualization of the right-click menu of the browser 
        event.preventDefault();

        // we record the mouse position in our object 
        this.menuTopLeftPosition.x = event.clientX;
        this.menuTopLeftPosition.y = event.clientY;

        // we open the menu 
        // we pass to the menu the information about our object 
        this.matMenuTrigger.menuData = { item: selectedItem };

        // we open the menu 
        this.matMenuTrigger.openMenu();
    }

    /**
     * Toggle star
     */
    toggleStar(asset: Asset): void {
        //this.isLoading = true;
        asset.favourite = asset.favourite ? !asset.favourite : true;
        this.favService.favorite(asset.id, asset.favourite).then((res) => {
            if (!asset.favourite) {
                this.toasterService.warning("Removed from favorite")
            } else {
                this.toasterService.info("Added to favorite")
            }
            this.getRecentAssets()
            this.eventSer.checkUnreadMessages.emit("favourite");
        }).catch((error) => {
            console.log(error);
        })
    }

    /**
     * Toggle star
     */
    toggleStar_multi(): void {
        // Update the asset
        if (this.selectedRows.length <= 0) {
            return;
        }
        const isAllFavSelected=this.selectedRows.every(row=>row.favourite==true)
        const ids=this.selectedRows.map(row => {
            return row.id
        })
        this.favService.favorite(ids,!isAllFavSelected).then(res => {
            this.getRecentAssets()
        }).catch(error=>{
            console.log(error)
        })
    }

    /**
     * Toggle the filterPanel open and close
     */
    toggleFilterPanel(): void {
        // toggle the filterPanel open and close
        this.filterPanel.toggle();
        // TODO - clear the filters on close

        //if opening the filterPanel, close the multiItemSelectPanel
        if (this.filterPanel.opened) {
           this.cancelBulkAction()
        }

        //TODO - if filter panel is open and then user makes a parameter selection, 
        //close multiItemSelectPanel and clear selectedRows.
    }
  
       /**
     * 
     * @param item 
     * Select rows by clicking on the available row space
     */
       onSelect(file: Asset, index: number, event: MouseEvent) {

        const isDrawerOpened = this.matDrawer.opened
        if(isDrawerOpened){
        this.drawerView( file.id ) 
        return
        }
        //suppress selection of the row if file is locked
        if (this.isRequestable(file)) return

        console.log(`Clicked index: ${index}, Last selected index: ${this.lastSelectedIndex}, Shift key: ${event.shiftKey}`);
        const isSelected = this.selectedRows.some(selectedFile => selectedFile.id === file.id);
        if (event.shiftKey && this.lastSelectedIndex !== -1) {

        if (isSelected) {
            // Deselect the row if it's already selected
            this.selectedRows = this.selectedRows.filter(selectedFile => selectedFile.id !== file.id);
        } else {
            // For multiple selection, add the current selection
            this.selectedRows = [...this.selectedRows,file];
            this.lastSelectedIndex = index; // Update last selected index for future shift selections
        }
        } else {
         
            if (isSelected) {
                // Deselect the row if it's already selected
                this.selectedRows = this.selectedRows.filter(selectedFile => selectedFile.id !== file.id);
            } else {
                // For single selection, replace the current selection
                this.selectedRows = [file];
                this.lastSelectedIndex = index; // Update last selected index for future shift selections
            }
        }
    
        // Panel visibility logic remains the same
        if (this.selectedRows.length > 0) {
            this.multiItemSelectPanel.open();
        } else {
            this.multiItemSelectPanel.close();
        }

          // Log the current selection for debugging
        console.log(`Selected rows:`, this.selectedRows.map(item => item.id));
    }

    // Helper function to check if a row is selected
    isSelected(file: any): boolean {
        return this.selectedRows.some(selectedFile => selectedFile.id === file.id);
    }

    cancelBulkAction(): void {
        this.selectedRows = [];
        this.multiItemSelectPanel.close();
        this.isAllRowsSelected = false;
    }

    download(asset : Asset): void {
        this._fileManagerService.openDialog_download(asset);
    }

    /**
     * Downloads multiple files as a zip.
     * Files will be identified in the backend by the selectedRows array.
     * For each file, checks if the user has permission to download.
     * If the user does not have permission, rejects all and returns an error message.
     * If the user has permission, downloads the files as a zip.
     */
    download_multi(): void {
        //TODO - download multiple files as a zip. Files will be identified in the backend by the selectedRows array. 
        //For each file, check if user has permission to download. If no permission, reject all and return error message.
        //If user has permission, download as zip.
        let assetIds: string[] = []
        if (this.selectedRows.length>1) {
            assetIds = this.selectedRows.map((x) => x.id);
            this._fileManagerService.openDialog_download_multi(assetIds)
        }
        else {
            const asset = this.selectedRows[0]
            this._fileManagerService.openDialog_download(asset);
        }
    }

    /**
     * Moves the specified file to the trash.
     * 
     * @param file - The file to be moved to the trash.
     * @param type - The type of file being moved to the trash.
     */
    trash(file:Asset): void {
        const ids:string[]=[file.id]
        this._fileManagerService.openDialog_trash(ids, file.type.toLowerCase());
    }

    /**
     * Trashes the selected assets.
     * If only one asset is selected, it trashes that asset.
     * If multiple assets are selected, it presents a confirmation prompt and then trashes all selected assets.
     */
    trash_multi(): void {
        if (this.selectedRows && this.selectedRows.length === 1) {
            this.trash(this.selectedRows[0]);
        } else {
            const ids:string[]=this.selectedRows.map(row=>row.id)
            this._fileManagerService.openDialog_trash_multi(ids);
        }
    }

    /**
     * Copies an asset.
     * 
     * @param asset - The asset to be copied.
     */
    copyAsset(asset : Asset){
        let assetIds:string[]=[]
        if(this.selectedRows.length){
            assetIds=this.selectedRows.map(row=>{
                return row.id
            })
        }
        else
        {
            assetIds=[asset.id]
        }
        this.docService.copyAsset(assetIds, asset?.parent?.id).then(res=>{
            const itemStr=this.util.pluralize('item',this.selectedRows.length)
            this.toasterService.info(`${itemStr} copied`);
            this.getRecentAssets();
        }).catch(error=>{
            console.log(error);
        })
    }

    /**
     * Stops the propagation of the specified mouse event.
     * 
     * @param event - The mouse event to stop propagation for.
     */
    stopPropagation(event: MouseEvent): void {
        this._fileManagerComponent.stopPropagation(event);
    }

    /**
     * Returns the color associated with the given file type.
     * 
     * @param filetype - The file type.
     * @returns The color associated with the file type.
     */
    getTypeColor(filetype: string): string {
        return this.util.getTypeColor(filetype);
    } 

    onFilterChange(event){
        this.assetsSearch=event
        this.getRecentAssets()
    }

    configFilter(){
        this.assetsSearch.sortDirection='DESCENDING'
        this.assetsSearch.sortColumn='UPDATED_DATE'
    }

    selectedLabel(id,list:any[]) {
        if(list) {
        const index=list.findIndex(item=>item.id===id)
        return index==-1 ? false : true;
        }
    }
   
    toggleLabel(assetId, labelId, event : MatCheckbox): void {
        if(!event.checked){
        this.labelService.assignLabel(labelId, assetId).then((res) => {
            this.toasterService.info("Label applied");
            this.getRecentAssets();
        }).catch((error) => {
            console.log(error);
        })
    } else this.deleteLabel(labelId, assetId);
    }

    deleteLabel(labelId,assetId){
        this.labelService.removeLabel(labelId, assetId).then((res)=>{
            this.toasterService.warning("Label removed");
            this.getRecentAssets();
        }).catch((error)=>{
            console.log(error);
        })
    }

    /**
     * Moves the specified asset to a different location.
     * If multiple rows are selected, it calls the `move_multi` method.
     * Otherwise, it opens the move item dialog for the selected asset.
     * 
     * @param item - The asset to be moved.
     */
    move(item: Asset): void {
         if(!this._permissionsService.canMove(item)){
            this.toasterService.error("You do not have permission to move this item.");
            return;
        }

        if (this.selectedRows.length > 1) {
            this.move_multi();
        } else {
            this._fileManagerComponent.moveItemDialog(item);
        }
    }

    /**
     * Moves multiple selected rows to a new location.
     */
    move_multi(): void {
         this.selectedRows.forEach(row => {
            if(!this._permissionsService.canMove(row)){
                this.toasterService.error(`You do not have permission to move ${row.name}.`);
                return;
            }
        });
        this._fileManagerComponent.moveItemDialogMuti(this.selectedRows);
    }

    /**
     * Checks if any selected row cannot be moved.
     */
    isAnyCanNotBeMoved(): boolean {
        return this.selectedRows.some((asset: Asset) => !this._permissionsService.canMove(asset));
    }

    renderTeamMembers() {
        this.assets.forEach((asset:Asset) => {
			asset["innerDiv"] = "";

			if (asset.createdBy.profilePic) {
				asset["innerDiv"] +=`<img
                class="shrink-0 w-10 h-10 mr-4 rounded-full overflow-hidden object-cover object-center"
                src="${asset.createdBy.profilePic}"
                [alt]="'Activity image'">`;
			} else {
				let name = getFullName(asset.createdBy).toUpperCase();
				const [first, last] = name.split(" ");
				this.teamDecorator[name] = (first?.substring(0, 1) || '') + (last?.substring(0, 1) || '');
				asset["innerDiv"] += ` <div class=" ${this.util.getUserColor(
					name
				)} flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full font-10">
               ${this.teamDecorator[name]}
            </div>`;
			}
        });
        this.itemDecoratorComplete = true;
	}

    checkoutAsset(asset:Asset){
        const ids:string[] = [asset.id];
        this.lockService.checkOutAsset(ids).then(res=>{
            this.toasterService.success("Locked SuccessFully",'Success');
            this.getRecentAssets();
        }).catch(error=>{
            console.log(error);
        })
    }

    checkInAsset(asset:Asset){
        const ids = [asset.id];
        this.isLoading = true;
        this.lockService.checkInAsset(ids).then(res=>{
            this.isLoading = false;
            this.toasterService.success("Unlocked Successfully",'Success');
            this.getRecentAssets();
        }).catch(error=>{
            this.isLoading = false;
            console.log(error);
        })
    }

    requestRelease(asset:Asset){
        const dialogRef = this._fuseConfirmationService.open({ message:`<b>"${asset.name}"</b> is locked. Press Confirm to Request Access.`, icon: { color: 'primary', name: 'feather:move' } });

        // Subscribe to afterClosed from the dialog reference
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'confirmed') {
                const ids = [asset.id];
                this.isLoading = true;
                this.lockService.requestRelease(ids).then(res=>{
                    this.isLoading = false;
                    this.toasterService.success("Released request sent successfully",'Success')
                    this.getRecentAssets()
                }).catch(error=>{
                    this.isLoading = false;
                    console.log(error);
                })
               
            }
        });
    
    }

    isCheckedIn(asset: Asset): boolean {
        return this.util.isCheckedIn(asset) 
    }
    isCheckedOut(asset:Asset){
        return this.util.isCheckedOut(asset)
    }
    isRequestable(asset: Asset): boolean {
        return this.util.isRequestable(asset)
    }
    isLockedForCurrentUser(asset: Asset): boolean {
       return this.util.isLockedForCurrentUser(asset)
    }

       /**
     * Sets the `assetId` and `activeTab` properties based on the provided `id` and `tab` values.
     * @param id - The ID of the asset.
     * @param tab - The active tab index (default is '0').
     */
       drawerView(id, tab = null){
        const currentPath = this._router.url;
        if(this.defaultView){
            this.assetId = id;
            this.activeTab = tab ? tab : '0';
            
        } else {
            if(tab)
            this._router.navigate(currentPath.includes('/details/') ? ['apps/file-manager/recent/details/', id] : [currentPath+'/details/', id], { queryParams: { activeTab: tab }});
            else
            this._router.navigate(currentPath.includes('/details/') ? ['apps/file-manager/recent/details/', id] : [currentPath+'/details',id] );
        }
    }

    editFile(asset: Asset) {
        this.editFileInNewApp(asset, false) //edit existing file
    }

    createNewFile() {
        this.editFileInNewApp(null, true) //create new file
    }

      /**
     * Opens the file in a new tab for preview after getting temporary token for authentication
     * @param asset - The asset object to be opened.
     */
      previewFile(asset:Asset){
        this.util.viewFile(asset);
    }

    /**
     * Opens the file in a new tab for editing after getting temporary token for authentication
     * @param asset - The asset to edit.
     * @param isNew - Indicates whether the asset is new or not. Default is false.
     */
    editFileInNewApp(asset: Asset, isNew: boolean = false) {

        // first get temporary token for authentication

        const assetId = isNew ? this.routeFolderId : asset.id;
        const assetName = isNew ? "new_doc" : encodeURIComponent(asset.name);

        this.authService.getToken().then((res) => {
            const token = this.docService.getData(res).token
            const dms_editor_url=this.util.getDmsEditorUrl()
            const user_type=this.util.getIsWebApp() ?'L':'D'
            const url = dms_editor_url + "/#/auth/" + assetId + "/" + "?name=" + assetName + "&new=" + isNew + "&t=" + token+"&dut="+user_type ;;
            this.util.openExternalViewEditLink(url);
        })
            .catch((err) => {
                console.log(err);
            });
    }

    toggleCheckAll():void {

        this.isAllRowsSelected = !this.isAllRowsSelected;

        if (this.isAllRowsSelected) {
            this.selectedRows = this.assets;
        }
        if (!this.isAllRowsSelected) {
            this.selectedRows = [];
        }

        this.toggleMultiRowSelectedOptions()
    }

    toggleRowCheck(checked: boolean, asset: Asset = null):void {

        if (checked) {
            this.selectedRows.push(asset)
        } else {
            this.selectedRows = this.selectedRows.filter(row => row.id !== asset.id);
        }

        this.isAllRowsSelected = this.selectedRows.length === this.assets.length;

        this.toggleMultiRowSelectedOptions()

    }

    resetSelectedRows():void {
        this.selectedRows = [];
        this.isAllRowsSelected = false;
        this.multiItemSelectPanel.close();
    }

    isSelectedRow(asset: Asset):boolean {
        return this.selectedRows.some(item => item.id === asset.id)
    }

    isFolderRowSelected():boolean {
        const index = this.selectedRows.findIndex(row => row.type == 'FOLDER')
        return index !== -1
    }

    toggleMultiRowSelectedOptions():void {
        if (this.selectedRows.length > 0) {
            this.multiItemSelectPanel.open();
            this.eventSer.multiRowSelect.emit();
        } else {
            this.multiItemSelectPanel.close();
        }
    }

    onRowClick(file:Asset){
        const isSelected = this.isSelectedRow(file);
        this.toggleRowCheck(!isSelected, file);
    }

    drawerViewClick(id: string): void {
        this._clicks.click(() => this.drawerView(id));
    }

    drawerViewDblClick(asset: Asset): void {
        this._clicks.dblClick(() => {
            if (this._actionRegistry.isAllowed('view', asset)) {
                this.previewFile(asset);
            } else if (this._actionRegistry.isAllowed('openOnDesktop', asset)) {
                this._desktopAgentService.launch(asset);
            } else {
                this.drawerView(asset.id);
            }
        });
    }

    /**
     * onDragStart:
     * catch the drag start event; configure the UI representation of the draggable item
    */
    onDragStart(event, asset: Asset){
    
        const img = this.util.createDragImage(asset);
        document.body.appendChild(img);
        event.dataTransfer.setDragImage(img, 0, 0);
        
        setTimeout(() => document.body.removeChild(img), 0);
        
    }

}
